import { useState, useRef } from "react";
import './PhoneAnimComponent.css';
import { useScrolledInto, useScrollRange } from '../responsive/scroll';
import iPhoneImg from '../Images/iphone-transp3.png';
import iPhoneBG from '../Images/iphone-bg-img.png';
import iPhoneFlameBG from '../Images/flame_phone2.png';
import iPhoneActivityBG from '../Images/activity_phone.png';
import iPhoneLockScreen from '../Images/lock_screen.png';
import iPhoneAppleMaps from '../Images/apple_maps_ss.png';
import orbiinIcon from '../Images/orbiin_logo_white.png';
import SlowDown from '../Images/slow-down.png';
import RightTurn from '../Images/right-turn.png';
import AmbulanceRed from '../Images/ambulance_red.png';
import PhoneScreenshot from '../Images/ems-sticker-phone-screen.png';
import fdnyThanks from '../Images/thank-you-fdny.png';
import emsThanks from '../Images/ems-sticker.png';
import iPhoneImgNotch from '../Images/iphone-transp-no-notch.png';
import orbiinIconYellow from '../Images/orbiin_logo_yellow_GOOD.png';
import RecognitionAnim from '../Images/recognition-anim.gif';
import PlayButton from '../Images/play-button.png';

const OverlayGraphic = () => {
    const sectionRef = useRef(null);
    // "Connected to Every Map" box slides in (was scrollPosition > 4400)
    const showConnected = useScrolledInto(sectionRef, 0.354);
    const [ isPlaying, setIsPlaying ] = useState(false);
    const videoRef = useRef(null);
    const handleImageClick = async () => {
        setIsPlaying(true);
        
        setTimeout(async () => {
        const video = videoRef.current;
        if (video) {
            try {
            if (video.requestFullscreen) {
                await video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) {
                video.webkitRequestFullscreen(); // older iPadOS Safari
            } else if (video.webkitEnterFullscreen) {
                video.webkitEnterFullscreen(); // iPhone Safari (video-only fullscreen)
            }
            video.play();
            } catch (err) {
            console.error("Error attempting to enable full-screen mode:", err);
            }
        }
        }, 50);
    };
    const handleFullscreenChange = () => {
        if (!(document.fullscreenElement || document.webkitFullscreenElement)) {
            setIsPlaying(false);
            if (videoRef.current) {
            videoRef.current.pause();
            }
        }
    };

    return <div ref={sectionRef} className="grid-parent overlay-layout" id="demo">
        <div className="overlay-title-layout">
            <span className="title overlay-title">Overlay</span><br/>
            <span className="overlay-subtitle">An adaptive layer that floats above your apps</span>
        </div>

        { showConnected ? (
            <div className="connected-box">
                <div className="connected-text">
                    Connected to <span className="bold-connected">Every Map</span><br/>
                    No need to switch apps<br/>
                    <span className="bold-connected">Orbiin</span> overlays Apple, Google, or Waze<br/>
                    enhancing what you already use with<br/>
                    invisible intelligence
                </div>
            </div>
        ) : "" }

        <div className="orbiin-graphic-box">
            <img id="orbiin-display" src={orbiinIconYellow} alt="Orbiin Logo Display"/>
        </div>

        <div className="active-orbiin-box">
            Active Orbiin icon is set at 50% opacity<br/>
            and ready to respond to user actions
        </div>

        <div id="overlay-line-1">
            <div id="overlay-dot-1" className="dot">
                <div className="dot-orange-transparent dot-outer dot-orange-animate">
                    <div className="dot-orange dot-inner"></div>
                </div>
            </div>
        </div>

        <div className="phone-graphic-box phone-overlay-placement" onClick={handleImageClick}>
            <img id="iphone-img" src={iPhoneImg} alt="iPhone"/>
            <img id="orbiin-ovl" src={orbiinIconYellow} alt="Orbiin App Overlay"/>
            {<img id="play-icon" src={PlayButton} alt="Press to play video"/>}
            <div className="phone-mask">
                <img id="iphone-bg" src={iPhoneLockScreen} alt="Wallpaper"/>
                {isPlaying && (
                    <video
                        ref={(el) => {
                            videoRef.current = el;
                            // Safari fires its own event names when leaving fullscreen
                            if (el && !el.dataset.fsBound) {
                                el.dataset.fsBound = '1';
                                el.addEventListener('webkitfullscreenchange', handleFullscreenChange);
                                el.addEventListener('webkitendfullscreen', () => {
                                    setIsPlaying(false);
                                    el.pause();
                                });
                            }
                        }}
                        id="user-demo-video"
                        autoPlay
                        muted
                        playsInline
                        controls
                        onFullscreenChange={handleFullscreenChange}
                    >
                        <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/make_way_user_demo_formatted.mp4" type="video/mp4" />
                    </video>
                )}
            </div>
        </div>
        <div id="right-hand-mask"></div>

        </div>
}

const LiveUpdates = () => {
    return <div className="viewport grid-parent live-updates-layout">
        <div className="live-updates-header grid-parent">
            <span className="title speed-title">Speed Zones. Rerouting. Alerts.</span>
            <span className="live-update-subtitle">Live updates designed to keep YOU one step ahead</span>
        </div>

        <div className="phone-graphic-box phone-live-updates-placement">
            <img id="iphone-img" src={iPhoneImgNotch} alt="iPhone"/>
            <div className="phone-mask">
                <div className="app-icons"></div>
                <img id="iphone-bg" src={iPhoneAppleMaps} alt="Wallpaper"/>
            </div>
        </div>
        <div className="pill-foreground grid-parent">
            <div className="big-pill limit-pill white-pill-shadow">
                <span id="limit-zone">Limit zone in 1 mile</span>
                <img id="slow-down-img" src={SlowDown} alt="Slow Down road sign" />
            </div>

            <div className="big-pill delay-pill">
                <div id="five-min-delay">
                    5 min delay ahead<br />
                    Take the next turn
                </div>
                <img id="right-turn-img" src={RightTurn} alt="Right Turn road sign" />
            </div>

            <div className="big-pill emergency-pill">
                <div id="on-your-route">
                    Emergency vehicle<br />
                    on your route!
                </div>
                <img id="ambulance-red-pill" src={AmbulanceRed} alt="Ambulance vehicle with red cross" />
            </div>
        </div>
    </div>
};

const Stickers = () => {
    return <div className="viewport stickers-layout grid-parent">
        <div className="title sticker-title">Stickers</div>

        <div className="phone-graphic-box phone-stickers-placement">
            <img id="iphone-img" src={PhoneScreenshot} alt="Phone map app with sticker screenshot"/>
        </div>

        <div className="left-section">
            <div className="sticker-box">
                <div className="sticker-inner-box">
                    <img className="fdny-sticker" src={fdnyThanks} alt="FDNY Thanks You sticker"/>
                    <img className="ems-sticker" src={emsThanks} alt="EMS Great Job sticker"/>
                </div>
            </div>

            <div className="connecting-line">
                <div className="dot-container-stickers dot">
                    <div className="dot-black-transparent dot-outer dot-black-animate">
                        <div className="dot-black dot-inner">
                            <div className="dot-nucleus dot-white"></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="sub-paragraph">
                <div>
                    Digital thank-yous for drivers who make way for
                    first responders
                <br />
                    A small gesture that makes a big difference
                </div>
            </div>
        </div>
    </div>
};

const ProfileScreen = () => {
    const sectionRef = useRef(null);
    // Milestones note is uncovered while the section is in place (was scroll range 8747–9293)
    const revealMilestones = useScrollRange(sectionRef, 0.641, -0.070);
    return <div ref={sectionRef} className="grid-parent profile-screen-layout">
        <span className="title profile-title">Profile Screen</span>

        <div className="profile-left-section">
            <div className="drive-to-donate-box">
                <span className="drive-to-donate-title">DRIVE to DONATE</span>
                <div className="drive-to-donate-p">
                    Every 50 miles support first responders,
                    schools or parks
                </div>
                <div className="donate-button">Donate</div>
                <div className="donate-close-button">✗</div>
            </div>

            <div className="profile-line-2"></div>

            <div className="profile-text profile-box-1">
                A banner that turns good driving into
                good deeds. Right from your Profile,
                you can donate earned points to support
                the people and places that shape your city
            </div>
            <div className="milestones-box">
                <div className="milestones-mask" style={revealMilestones ? {marginRight: '384px'} : {}}></div>
                <div className="milestones-text">
                    Appears when reward milestones are reached<br />
                    Supports verified city causes
                </div>
            </div>

            <div className="profile-line-1"></div>

            <div className="profile-text profile-box-2">
                Powered by <span className="orb-bold">Orbiin AI</span> personalized tips,
                feedback, and trends from your daily drives
            </div>
        </div>

        <div className="phone-graphic-box phone-profile-placement">
            <img id="iphone-img" src={iPhoneImg} alt="iPhone"/>
            <div className="phone-mask">
                <div className="app-icons"></div>
                <img id="iphone-activity-bg" src={iPhoneActivityBG} alt="Wallpaper"/>
            </div>
        </div>

        <div className="profile-right-section">
            <div className="profile-line-3"></div>
            <div className="profile-text profile-box-3">
                Daily activity blocks
                show your driving
                footprints across the city
            </div>
        </div>
    </div>
};

const DriveWinEarnRepeat = () => {
    return <div className="drive-viewport grid-parent drive-win-layout drive-win-background">
        <div className="drive-right-section">
            <div className="drive-box first-box">
                <span className="drive-title">Drive</span>
                <div className="drive-subtitle">
                    Focus on safe<br />
                    and smart driving
                </div>
            </div>

            <div className="drive-box">
                <span className="drive-title">Win</span>
                <div className="drive-subtitle">
                    Compete on leaderboards<br />
                    and unlock rewards
                </div>
            </div>

            <div className="drive-box earn-box">
                <span className="drive-title">Earn</span>
                <div className="drive-subtitle">
                    Collect points, badges<br/>
                    and micro-credits for positive actions
                </div>
            </div>

            <div className="drive-box">
                <span className="drive-title">Repeat</span>
                <div className="drive-subtitle">
                    Do it again tomorrow<br/>
                    it's a daily challenge and habit loop
                </div>
            </div>
        </div>

        <div className="phone-drive-graphic-box phone-drive-placement">
            <img id="iphone-drive-img" src={iPhoneImg} alt="iPhone"/>
            <div className="phone-mask-2">
                <div className="app-icons"></div>
                <img id="iphone-flame-bg" src={iPhoneFlameBG} alt="Wallpaper"/>
            </div>
        </div>
    </div>
}

const UserDemoVideoComponent = () => {
    return <div className="viewport grid-parent user-demo-layout">
        <div class="title user-demo-title">See Orbiin in Action</div>
        <video
            id="user-demo-video"
            className="full-page-video"
            autoPlay
            loop
            muted
            playsInline
            controls
        >
            <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/make_way_user_demo_formatted.mp4" type="video/mp4" />
        </video>
    </div>
}

const phoneGraphic = () => {
    return <div className="phone-graphic-box">
            <img id="iphone-img" src={iPhoneImg} alt="iPhone"/>
            <img id="orbiin-ovl" src={orbiinIcon} alt="Orbiin App Overlay"/>
            <div className="phone-mask">
                <div className="app-icons"></div>
                <img id="iphone-bg" src={iPhoneBG} alt="Wallpaper"/>
            </div>
        </div>
}

const PhoneAnimComponent = () => {
    // const parentRef = useRef(null);
    // const [divScrollPosition, setDivScrollPosition] = useState(0);

    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (parentRef.current) {
    //             setDivScrollPosition(parentRef.current.scrollTop);
    //         }
    //     };

    //     const parentDiv = parentRef.current;
    //     if (parentDiv) {
    //         parentDiv.addEventListener('scroll', handleScroll);
    //     }

    //     return () => {
    //         if (parentDiv) {
    //             parentDiv.removeEventListener('scroll', handleScroll);
    //         }
    //     };
    // }, []);

    return <div>
        <div>
        <OverlayGraphic />
        <LiveUpdates />
        <div class="live-updates-dividing-line"></div>
        <div class="blurb">
            Orbiin detects what matters on your route. <br/>
            Whether you're navigating, listening to the <br/>
            music, or on a call, you'll receive timely <br/>
            alerts about important events ahead.
        </div>
        <Stickers />
        <ProfileScreen />
        <DriveWinEarnRepeat />
        <div className="recog-anim">
            <img src={RecognitionAnim} id="recog-img" alt="Orbiin Logo Animation"/>
        </div>
        </div>
    </div>
};

export default PhoneAnimComponent;